// Meta Pixel helper utilities
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

export const trackAddToCart = (id: string, name: string, value: number, currency = "BRL") => {
  if (typeof window.fbq === "function") {
    window.fbq("track", "AddToCart", {
      content_ids: [id],
      content_name: name,
      content_type: "product",
      value,
      currency,
    });
  }
};

export const trackInitiateCheckout = (value: number, numItems: number, currency = "BRL") => {
  if (typeof window.fbq === "function") {
    window.fbq("track", "InitiateCheckout", {
      value,
      currency,
      num_items: numItems,
    });
  }
};

export const trackPurchase = (value: number, currency = "BRL", orderId?: string) => {
  if (typeof window.fbq === "function") {
    window.fbq("track", "Purchase", {
      value,
      currency,
      ...(orderId && { content_name: `Pedido ${orderId.slice(0, 8)}` }),
    });
  }
};
